import { Building2 } from 'lucide-react';
import { Button } from '../ui/button';
import type { Company, TaxInvoiceTranslations } from './types';

interface CompanySelectorProps {
  company: Company | null;
  t: TaxInvoiceTranslations;
  isGenerating: boolean;
  onShowCompanyList: () => void;
}

export function CompanySelector({
  company,
  t,
  isGenerating,
  onShowCompanyList
}: CompanySelectorProps) {
  return (
    <div>
      <h3 className="font-medium text-gray-900 mb-3">
        {company ? t.selectedCompany : t.selectCompany}
      </h3>

      {company ? (
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start gap-3">
              <Building2 className="w-5 h-5 text-gray-400 mt-0.5" />
              <div>
                <h4 className="font-medium text-gray-900">{company.name}</h4>
                <p className="text-sm text-gray-600 font-mono">RFC: {company.rfc}</p>
                <p className="text-sm text-gray-500 mt-1">{company.address}</p>
                {company.email && (
                  <p className="text-sm text-gray-500">{company.email}</p>
                )}
              </div>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={onShowCompanyList}
            className="mt-3"
            disabled={isGenerating}
          >
            {t.changeCompany}
          </Button>
        </div>
      ) : (
        <Button
          onClick={onShowCompanyList}
          variant="outline"
          className="w-full p-4 h-auto border-dashed"
          disabled={isGenerating}
        >
          <div className="flex items-center gap-2">
            <Building2 className="w-5 h-5" />
            <span>{t.selectCompany}</span>
          </div>
        </Button>
      )}
    </div>
  );
}
